import { render, staticRenderFns } from "./EntityMediaWrapper.vue?vue&type=template&id=cdd0c5bc&scoped=true&"
import script from "./EntityMediaWrapper.vue?vue&type=script&lang=js&"
export * from "./EntityMediaWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd0c5bc",
  null
  
)

export default component.exports